import { ImpersonationSuccessToast } from 'shared/components/toasts/ImpersonationSuccessToast';

export enum ToastCustomContentKey {
    ImpersonationSuccess = 'impersonationSuccess'
}

export const customContentToastMapper: Record<ToastCustomContentKey, () => JSX.Element> = {
    [ToastCustomContentKey.ImpersonationSuccess]: ImpersonationSuccessToast,
};
